import {
    createRegisterableComponentWithData,
    CurationAndCurationMetadataLoader,
} from '@news-mono/web-common'
import React, { ReactElement } from 'react'
import { TNArticleCards } from './TNArticleCards'

export const TNArticleCardsRegistration = createRegisterableComponentWithData(
    'tn-article-cards',
    CurationAndCurationMetadataLoader,
    (
        props: {
            displayPublicationDate?: boolean
            renderBasicTeaser?: boolean
            displayKicker?: boolean
            hideBorder?: boolean
            sectionHeading?: string
            icon?: {
                IconElement: ReactElement
            }
        },
        data,
        { onEvent },
    ) => {
        return (
            <TNArticleCards
                data={data}
                onEvent={onEvent}
                displayPublicationDate={props.displayPublicationDate}
                renderBasicTeaser={props.renderBasicTeaser}
                displayKicker={props.displayKicker}
                hideBorder={props.hideBorder}
                sectionHeading={props.sectionHeading}
                icon={props.icon}
            />
        )
    },
)
